import { render } from "./CampaignsList.vue?vue&type=template&id=b64bd502&scoped=true"
import script from "./CampaignsList.vue?vue&type=script&lang=js"
export * from "./CampaignsList.vue?vue&type=script&lang=js"

import "./CampaignsList.vue?vue&type=style&index=0&id=b64bd502&lang=scss&scoped=true"
import "./CampaignsList.vue?vue&type=style&index=1&id=b64bd502&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b64bd502"]])

export default __exports__